let questionSocket = undefined;
const PROD_SCHEME= `wss`;
const DEV_SCHEME= `ws`;

export class QuestionWebSocketService {

  startWebSocket() {
    const scheme = (process.env.NODE_ENV === "development") ? DEV_SCHEME : PROD_SCHEME;
    const url = `${scheme}://${location.host}/ws/question`;
    let ws = new WebSocket(url);
    ws.binaryType = "arraybuffer";
    ws.onclose = event => {
      if (event.wasClean) {
        console.log(`[close] Connection closed cleanly, code=${event.code} reason=${event.reason}`);
      } else {
        // e.g. server process killed or network down
        // event.code is usually 1006 in this case
        console.log("[close] Connection died");
      }
      ws = null;
    };

    ws.onerror = errorEvent => console.error("[error]", errorEvent);
    return ws;
  }

  bindOnMessage(eventFunction) {
    if (questionSocket === undefined) {
      questionSocket = this.startWebSocket();
    }
    questionSocket.onmessage = eventFunction;
    if (questionSocket.readyState !== questionSocket.OPEN) {
      questionSocket.onopen = () => this.sendGoToFirstPage();
    } else {
      this.sendGoToFirstPage();
    }
  }

  reconnectWebsocket() {
    questionSocket = this.startWebSocket();
  }

  sendGoToFirstPage() {
    this.send({"action": "goToFirstPage"});
  }

  send(jsonObject) {
      const objectAsString = JSON.stringify(jsonObject);
      console.log("obj as string: ", objectAsString)
      questionSocket.send(objectAsString);
  }

}